module.exports = __webpack_public_path__ + "media/images/countrysquared/dj-af71f4af5168f405fc1a792eec8ec179.svg";